import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[cwGtmId]',
    standalone: false
})
export class GtmIdDirective implements OnInit {
    @Input('cwGtmId')
    public identifier!: string[];

    private readonly ID_ATTRIBUTE = 'data-gtm';
    private readonly ID_PREFIX = 'ux_';

    constructor(protected elementRef: ElementRef,
                protected renderer: Renderer2) {}

    public ngOnInit(): void {
        if (!this.identifier || !this.identifier.map) {
            return;
        }

        this.renderer.setAttribute(
            this.elementRef.nativeElement,
            this.ID_ATTRIBUTE,
            this.getGeneratedId(this.identifier)
        );
    }

    public getGeneratedId(path: string[] = []): string {
        const processedPath = path.map(item => item.replace(/ /g, '-'));
        return this.ID_PREFIX + processedPath.join('_');
    }
}
